export class FightError extends Error {
  constructor(message: string) {
    super('[FightError] ' + message);
  }
}

export class FightNotFoundError extends FightError {}
export class FightServerError extends FightError {}
